<template>
  <div class="px-2 md:px-0 md:w-1/2 mx-auto mb-8">
    <div class="flex justify-start items-center">
      <div class="text-xl font-bold text-gray-brand-900 tracking-tighter">Delivery Addresses</div>
    </div>
    <div class="mt-4 md:mt-6 bg-white">
      <div class="rounded-lg shadow-solid-xs border shadow-gray-brand-600 border-gray-brand-600">
        <div v-if="hasDeliveryAddresses" class="pt-4 pb-2 px-6 max-h-72 overflow-y-auto">
          <fieldset>
            <div class="leading-5">
              <DeliveryAddressRow
                v-for="deliveryAddress in customerDeliveryAddresses"
                :key="deliveryAddress.id"
                :delivery-address="deliveryAddress"
                @edit-address="editDeliveryAddress"
                @remove-address="removeDeliveryAddress"
              />
            </div>
          </fieldset>
        </div>
        <AddDeliveryAddressForm
          :passed-delivery-address="selectedDeliveryAddressForEdit"
          :force-open="false"
          @delivery-address-saved="onDeliveryAddressSaved"
          @delivery-address-edit-canceled="onDeliveryAddressEditCanceled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryAddressRow from './DeliveryAddressRow.vue'
import AddDeliveryAddressForm from './AddDeliveryAddressForm.vue'

export default {
  name: 'DeliveryAddressesSection',
  components: {
    DeliveryAddressRow,
    AddDeliveryAddressForm
  },
  data() {
    return {
      selectedDeliveryAddressForEdit: null,
      isLoading: false
    }
  },
  computed: {
    customer() {
      return this.$store.getters.customer
    },
    customerDeliveryAddresses() {
      return this.$store.getters.deliveryAddresses(this.customer?.relationships?.delivery_addresses?.data)
    },
    hasDeliveryAddresses() {
      return this.customerDeliveryAddresses && this.customerDeliveryAddresses.length > 0
    }
  },
  methods: {
    editDeliveryAddress(deliveryAddress) {
      this.selectedDeliveryAddressForEdit = deliveryAddress
    },
    removeDeliveryAddress(deliveryAddress) {
      if (confirm('Are you sure you want to remove this delivery address?')) {
        this.isLoading = true
        this.$store
          .dispatch('removeCustomerDeliveryAddress', {
            deliveryAddressID: deliveryAddress.id
          })
          .then(() => {
            this.isLoading = false
            this.$store.dispatch('getCustomerInfo', ['delivery_addresses'])
          })
          .catch(() => {
            this.isLoading = false
          })
      }
    },
    onDeliveryAddressSaved() {
      this.selectedDeliveryAddressForEdit = null
      this.$store.dispatch('getCustomerInfo', ['delivery_addresses'])
    },
    onDeliveryAddressEditCanceled() {
      this.selectedDeliveryAddressForEdit = null
    }
  }
}
</script>
